"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFunction = isFunction;
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/util/isFunction.js
// module id = 106
// module chunks = 0